<template>
    <div class="display-t border-b-1 border-color-b-010 border-solid padding-t-8 padding-b-8">
        <div class="display-tc vertical-align-m">
            <img :src="subtypeIcon" class="margin-r-5 width-20 height-20">
        </div>
        <div class="display-tc vertical-align-m width-0100">
            <span class="font-size-s">{{ listItem.properties.name }}</span>
            <p class="font-size-xs color-b-060">{{ listItem.sector }}</p>
        </div>
        <div class="display-tc vertical-align-m">
            <span class="display-ib width-50 text-align-c">
                <img :src="openingIcon">
            </span>
        </div>
        <div class="display-tc vertical-align-m" v-show="isTrail">
            <span class="display-ib width-80 text-align-c">
                <img :src="groomingIcon">
            </span>
        </div>
    </div>
</template>

<script>
  import _ from 'lodash'
  import fs from 'fs'

  export default {
    props: {
      listItem: {
        type: Object,
        required: true
      }
    },
    computed: {
      isTrail: function () {
        return this.listItem.type === 'trail'
      },
      subtypeIcon: function () {
        if (_.has(this.listItem, 'properties.subtype')) {
          try {
            return require('../assets/icons/' + this.listItem.properties.subtype + '.png')
          } catch (e) {
            if (this.listItem.type === "lift") {
              return require('../assets/icons/Lift.png')
            } else {
              return null;
            }
          }
        } else {
          if (this.listItem.type === "lift") {
              return require('../assets/icons/Lift.png')
            } else {
              return null;
            }
        }
      },
      openingIcon: function () {
        let status = _.find(this.listItem.status, { status_name: 'opening' })
        if (status !== undefined) {
          let value = status.status_value;
          if (status.status_value === "true") value = "open";
          if (status.status_value === "false") value = "closed";
          return require('../assets/icons/' + status.status_name + '_' + value + '.png')
        } else {
          return ''
        }
      },
      groomingIcon: function () {
        let status = _.find(this.listItem.status, { status_name: 'grooming' })
        if (status !== undefined) {
          return require('../assets/icons/' + status.status_name + '_' + status.status_value + '.png')
        } else {
          return ''
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ListItem.vue